<template>
  <v-container fluid v-if="isTestMode">
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des cumuls repas mensuels</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>

        <!-- Alerte pour les notifications -->
        <v-alert :color="AlertColor(type)"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>

        <!-- Modal de modification -->
        <modal :adaptive="true"
               :clickToClose="false"
               :draggable="false"
               :resizable="false"
               height="auto"
               name="modal-fade">
          <v-card>
            <v-toolbar
                color="#01579B"
                dark
                flat>
              <v-text-field :id="dynamicID()" class="text--darken-3 mt-3"
                            dense
                            hide-details
                            readonly
                            rounded
                            v-model="modifier">
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                  @click="hide()"
                  dark
                  fab
                  small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-alert :color="AlertColorS(typeS)"
                       :dismissible="true"
                       :value="true"
                       border="top"
                       class="pre-formatted multi-line"
                       colored-border
                       elevation="2"
                       icon="check_circle"
                       v-if="typeS">
                {{ text }}
              </v-alert>
              <v-container>
                <v-card-text>
                  <v-container>
                    <v-stepper v-model="e6" vertical>
                      <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                        Informations du cumul repas mensuel
                      </v-stepper-step>
                      <v-stepper-content step="1">
                        <v-row>
                          <v-col cols="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Matricule"
                                          v-model="editedItem.matricule"
                                          readonly></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Année"
                                          type="number"
                                          min="2020"
                                          max="2030"
                                          v-model="editedItem.annee"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-select :id="dynamicID()"
                                      class="centered-input"
                                      label="Mois"
                                      :items="months"
                                      item-text="text"
                                      item-value="value"
                                      v-model="editedItem.mois"></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Repas autorisés"
                                          type="number"
                                          min="0"
                                          max="31"
                                          v-model="editedItem.nombreRepasAutorises"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Repas consommés"
                                          type="number"
                                          min="0"
                                          v-model="editedItem.nombreRepasConsommes"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Quote-part salariale"
                                          type="number"
                                          min="0"
                                          v-model="editedItem.cumulQuotePartSalariale"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-btn @click="e6 = 2" class="mb-2"
                               color="primary"><span
                            class="material-icons"> done_all </span></v-btn>
                      </v-stepper-content>
                    </v-stepper>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="!FormIsValidModif" @click="updateCumulRepas()"
                         class="white--text"
                         color="#01579B" depressed>Modifier cumul
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </modal>

        <v-card class="mt-1" flat tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export cumuls repas</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" persistent v-model="dialog">
                <template v-slot:activator="{ on }">
                  <v-btn @click="init()" block class="custom-btn white--text" color="#009688" height="45px" large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Ajouter cumul</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-toolbar-title>Nouveau cumul repas mensuel</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-container>
                      <v-stepper v-model="e6" vertical>
                        <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                          Informations du cumul repas mensuel
                        </v-stepper-step>
                        <v-stepper-content step="1">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Matricule"
                                            v-model="editedItem.matricule"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Année"
                                            type="number"
                                            min="2020"
                                            max="2030"
                                            v-model="editedItem.annee"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-select :id="dynamicID()"
                                        class="centered-input"
                                        label="Mois"
                                        :items="months"
                                        item-text="text"
                                        item-value="value"
                                        v-model="editedItem.mois"></v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Repas autorisés"
                                            type="number"
                                            min="0"
                                            max="31"
                                            v-model="editedItem.nombreRepasAutorises"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Repas consommés"
                                            type="number"
                                            min="0"
                                            v-model="editedItem.nombreRepasConsommes"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Quote-part salariale"
                                            type="number"
                                            min="0"
                                            v-model="editedItem.cumulQuotePartSalariale"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-btn @click="e6 = 2" class="mb-2"
                                 color="primary"><span
                              class="material-icons"> done_all </span></v-btn>
                        </v-stepper-content>
                      </v-stepper>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="!FormIsValid" @click="createCumulRepas()"
                           class="white--text"
                           color="#01579B" depressed>Créer cumul
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="mt-4" elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>

  <!-- Message d'accès refusé en mode production -->
  <v-container fluid v-else>
    <v-card>
      <v-card-text class="text-center">
        <v-icon size="100" color="#F44336">mdi-lock</v-icon>
        <h2 class="mt-4 mb-2" style="color:#F44336">Accès Restreint</h2>
        <p class="text-subtitle-1">
          Cette fonctionnalité est uniquement disponible en mode test.<br>
          L'accès est bloqué en environnement de production pour des raisons de sécurité.
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "cumul_repas_mensuel",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      lastHighlitedRow: null,
      loading: false,
      loading2: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      modifier: "",
      typeS: null,
      type: null,
      elapse: null,
      errors: [],
      excelData: [],
      toObject: [],
      months: [
        {text: 'Janvier', value: 1},
        {text: 'Février', value: 2},
        {text: 'Mars', value: 3},
        {text: 'Avril', value: 4},
        {text: 'Mai', value: 5},
        {text: 'Juin', value: 6},
        {text: 'Juillet', value: 7},
        {text: 'Août', value: 8},
        {text: 'Septembre', value: 9},
        {text: 'Octobre', value: 10},
        {text: 'Novembre', value: 11},
        {text: 'Décembre', value: 12}
      ],
      editedItem: {
        id: "",
        matricule: "",
        nomPrenom: "",
        annee: new Date().getFullYear(),
        mois: new Date().getMonth() + 1,
        nombreRepasConsommes: 0,
        nombreRepasAutorises: 20,
        cumulQuotePartSalariale: 0,
        creationDate: "",
        revisedDate: ""
      },
      hotSettings: {
        renderAllRows: false,
        viewportRowRenderingOffset: 'auto',
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        contextMenu: {
          items: {
            modifier: {
              name: "Modifier",
              callback: (key, selection, clickEvent) => {
                setTimeout(() => {
                  let start = selection[0].start;
                  this.displayTitleModif(start.row);
                  this.updateData4Modif(start.row);
                  this.show();
                }, 0);
              }
            },
            remove_row: {
              name: "Supprimer",
              callback: (key, selection, clickEvent) => {
                setTimeout(() => {
                  let start = selection[0].start;
                  this.beforeRemoveRowMe(start.row, 1);
                }, 0);
              }
            }
          }
        },
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Matricule", "Nom Prénom", "Année", "Mois", "Repas Consommés", "Repas Autorisés", "Quote-part Salariale", "Date création", "Date révision"
        ],
        columns: [
          {title: "Id", width: "10px", readOnly: true},
          {title: "Matricule", width: "100px", readOnly: true},
          {title: "Nom Prénom", width: "150px", readOnly: true},
          {title: "Année", width: "80px", type: "numeric", readOnly: false},
          {title: "Mois", width: "80px", type: "numeric", readOnly: false},
          {title: "Repas Consommés", width: "120px", type: "numeric", readOnly: false},
          {title: "Repas Autorisés", width: "120px", type: "numeric", readOnly: false},
          {title: "Quote-part Salariale", width: "130px", type: "numeric", readOnly: false},
          {title: "Date création", width: "120px", align: "center", type: "date", readOnly: true},
          {title: "Date révision", width: "120px", align: "center", type: "date", readOnly: true}
        ]
      }
    }
  },

  created() {
    // Only load data if in test mode
    if (this.isTestMode) {
      this.getData();
    }
  },

  mounted() {
    window.show = this.show;
    window.displayTitleModif = this.displayTitleModif;
    window.updateData4Modif = this.updateData4Modif;
  },

  computed: {
    FormIsValid() {
      return (
          this.editedItem.matricule !== "" &&
          this.editedItem.annee >= 2020 &&
          this.editedItem.mois >= 1 && this.editedItem.mois <= 12 &&
          this.editedItem.nombreRepasAutorises >= 0 &&
          this.editedItem.nombreRepasConsommes >= 0 &&
          this.editedItem.cumulQuotePartSalariale >= 0
      );
    },
    FormIsValidModif() {
      return (
          this.editedItem.matricule !== "" &&
          this.editedItem.annee >= 2020 &&
          this.editedItem.mois >= 1 && this.editedItem.mois <= 12 &&
          this.editedItem.nombreRepasAutorises >= 0 &&
          this.editedItem.nombreRepasConsommes >= 0
      );
    },
    isTestMode() {
      const baseUrl = this.$store.getters.user.baseUrl;
      return baseUrl === "https://tests.eyone.cartaware.cartalink.com" || baseUrl.includes("localhost");
    }
  },

  methods: {
    displayTitleModif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row];
      this.modifier = "Modification cumul repas pour " + rowT[1] + " - " + this.getMonthName(rowT[4]) + " " + rowT[3];
    },

    updateData4Modif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row];
      this.editedItem.id = rowT[0];
      this.editedItem.matricule = rowT[1];
      this.editedItem.nomPrenom = rowT[2];
      this.editedItem.annee = rowT[3];
      this.editedItem.mois = rowT[4];
      this.editedItem.nombreRepasConsommes = rowT[5];
      this.editedItem.nombreRepasAutorises = rowT[6];
      this.editedItem.cumulQuotePartSalariale = rowT[7];
      this.editedItem.creationDate = rowT[8];
      this.editedItem.revisedDate = rowT[9];
    },

    getMonthName(monthNumber) {
      const month = this.months.find(m => m.value === monthNumber);
      return month ? month.text : monthNumber;
    },

    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },

    cleared() {
      this.searchName = "";
      this.getData();
    },

    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase();

      if (this.isEmpty(query)) {
        this.cleared();
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 0, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },

    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },

    show() {
      this.$modal.show('modal-fade');
    },

    hide() {
      this.$modal.hide('modal-fade');
    },

    init() {
      this.tab = "tab-1";
      this.file = "";
      this.initEditedItem();
    },

    initEditedItem() {
      this.editedItem = {
        id: "",
        matricule: "",
        nomPrenom: "",
        annee: new Date().getFullYear(),
        mois: new Date().getMonth() + 1,
        nombreRepasConsommes: 0,
        nombreRepasAutorises: 20,
        cumulQuotePartSalariale: 0,
        creationDate: "",
        revisedDate: ""
      };
    },

    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render();
    },

    getData() {
      this.loading = true;
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallet_cumul_repas_mensuel/` + sessionStorage.getItem("accountId")
          )
          .then(response => {
            this.loading = false;
            let tabArray = [];
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688";
              this.text = response.data.message;
              this.showAlert('warning');
              this.disableMainBtn = true;
            } else {
              this.disableMainBtn = false;
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["matricule"],
                item["nomPrenom"],
                item["annee"],
                item["mois"],
                item["nombreRepasConsommes"],
                item["nombreRepasAutorises"],
                item["cumulQuotePartSalariale"],
                this.datefull(item["creationDate"]),
                this.datefull(item["revisedDate"])
              ]);
            });

            this.$refs.hotTable.hotInstance.loadData(tabArray);
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
          })
          .catch(() => {
            this.loading = false;
          });
    },

    onCancel() {
      this.loading = false;
    },

    refresh() {
      this.getData();
    },

    datefull(val) {
      if (!val) {
        return;
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },

    close() {
      this.dialog = false;
      this.initEditedItem();
    },

    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },

    showAlert(type) {
      this.type = type;

      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null;
      }, 20000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },

    AlertColorS(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },

    showAlertS(type) {
      this.typeS = type;

      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        if (this.typeS === "info") {
          this.hide();
        }
        this.typeS = null;
      }, 20000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 4) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },

    dismissible_close() {
      this.elapse = 3;
      clearTimeout(this.showAlert.timer);
      clearInterval(this.showAlert.t);
      this.type = null;
    },

    onexport() {
      this.loading = true;
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true});
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, datas, "CumulRepasMensuel");
      XLSX.writeFile(wb, "CumulRepasMensuel.xlsx");
      this.loading = false;
    },

    createCumulRepas() {
      if (!this.FormIsValid) {
        return;
      }

      this.loading = true;

      const baseUrl = this.$store.getters.user.baseUrl;
      const matricule = encodeURIComponent(this.editedItem.matricule);
      const annee = this.editedItem.annee;
      const mois = this.editedItem.mois;
      const nombreRepasAutorises = this.editedItem.nombreRepasAutorises;
      const nombreRepasConsommes = this.editedItem.nombreRepasConsommes;
      const cumulQuotePartSalariale = this.editedItem.cumulQuotePartSalariale;
      const sender_id = sessionStorage.getItem("accountId");

      const url = `${baseUrl}/wallet/add_wallet_cumul_repas_mensuel/${matricule}/${annee}/${mois}/${nombreRepasAutorises}/${nombreRepasConsommes}/${cumulQuotePartSalariale}/${sender_id}`;

      apiClient
          .post(url)
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.dialog = false;
              this.getData();
              this.initEditedItem();
              this.showAlert('info');
            } else {
              this.color = "#F44336";
              this.text = res.data.message;
              this.dialog = false;
              this.showAlert('warning');
            }
          })
          .catch(err => {
            this.text = err;
            this.dialog = false;
            this.loading = false;
            this.color = "#F44336";
            this.showAlert('warning');
          });
    },

    updateCumulRepas() {
      if (!this.FormIsValidModif) {
        return;
      }

      this.loading = true;

      const baseUrl = this.$store.getters.user.baseUrl;
      const id = this.editedItem.id;
      const matricule = encodeURIComponent(this.editedItem.matricule);
      const annee = this.editedItem.annee;
      const mois = this.editedItem.mois;
      const nombreRepasAutorises = this.editedItem.nombreRepasAutorises;
      const nombreRepasConsommes = this.editedItem.nombreRepasConsommes;
      const sender_id = sessionStorage.getItem("accountId");

      const url = `${baseUrl}/wallet/update_wallet_cumul_repas_mensuel/${id}/${matricule}/${annee}/${mois}/${nombreRepasAutorises}/${nombreRepasConsommes}/${sender_id}`;

      apiClient
          .post(url)
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.hide();
              this.getData();
              this.initEditedItem();
              this.showAlertS('info');
            } else {
              this.color = "#F44336";
              this.text = res.data.message;
              this.showAlertS('warning');
            }
          })
          .catch(err => {
            this.text = err;
            this.loading = false;
            this.color = "#F44336";
            this.showAlertS('warning');
          });
    },

    afterChangeMe(changes, source) {
      if (!this.isTestMode) {
        let myData = this.$refs.hotTable.hotInstance.getData();
        myData[changes[0][0]][changes[0][1]] = changes[0][2];
        this.$refs.hotTable.hotInstance.loadData(myData);

        this.color = "#F44336";
        this.text = "Les modifications ne sont autorisées qu'en mode test.";
        this.showAlert('warning');
        return;
      }

      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du cumul repas mensuel.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true;
              let obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]];

              const baseUrl = this.$store.getters.user.baseUrl;
              const id = obj[0];
              const matricule = encodeURIComponent(obj[1]);
              const annee = obj[3];
              const mois = obj[4];
              const nombreRepasAutorises = obj[6];
              const nombreRepasConsommes = obj[5];
              const sender_id = sessionStorage.getItem("accountId");

              const url = `${baseUrl}/wallet/update_wallet_cumul_repas_mensuel/${id}/${matricule}/${annee}/${mois}/${nombreRepasAutorises}/${nombreRepasConsommes}/${sender_id}`;

              apiClient
                  .post(url)
                  .then(res => {
                    dialog.close();
                    this.loading = false;
                    if (res.data.status === 200) {
                      this.color = "#009688";
                      this.text = res.data.message;
                      this.showAlert('info');
                      this.getData();
                    } else {
                      this.color = "#F44336";
                      this.text = res.data.message;

                      let myData = this.$refs.hotTable.hotInstance.getData();
                      myData[changes[0][0]][changes[0][1]] = changes[0][2];
                      this.$refs.hotTable.hotInstance.loadData(myData);

                      this.showAlert('warning');
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    dialog.close();

                    let myData = this.$refs.hotTable.hotInstance.getData();
                    myData[changes[0][0]][changes[0][1]] = changes[0][2];
                    this.$refs.hotTable.hotInstance.loadData(myData);

                    this.color = "#F44336";
                    this.text = err.data ? err.data.message : err;
                    this.showAlert('warning');
                  });
            })
            .catch(() => {
              this.loading = false;
              let myData = this.$refs.hotTable.hotInstance.getData();
              myData[changes[0][0]][changes[0][1]] = changes[0][2];
              this.$refs.hotTable.hotInstance.loadData(myData);
            });
      }
    },

    beforeRemoveRowMe(index, amount) {
      if (!this.isTestMode) {
        this.color = "#F44336";
        this.text = "La suppression n'est autorisée qu'en mode test.";
        this.showAlert('warning');
        return false;
      }

      let rowId = this.$refs.hotTable.hotInstance.getData()[index];
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du cumul repas mensuel.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/wallet/delete_wallet_cumul_repas_mensuel/${rowId[0]}/${sessionStorage.getItem("accountId")}`
                )
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message;
                    this.showAlert('info');
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.color = "#F44336";
                    this.text = res.data.message;
                    this.showAlert('warning');
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false;

                  this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
                  this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                  this.color = "#F44336";
                  this.text = error;
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);
          });
    },

    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },

    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    }
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.centered-input >>> input {
  text-align: center !important;
}

.area.highlight,
.htCenter.htMiddle.highlight {
  background-color: #d0e1ef !important;
}

.v-select__selections {
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
}

.v-select__selection {
  margin: 0 !important;
  text-align: center !important;
}

.v-input--selection-controls__input {
  margin: 0 auto !important;
}

.v-select .v-select__selection--comma {
  margin: 0 auto !important;
  text-align: center !important;
  width: 100% !important;
  overflow: visible !important;
}

.v-select .v-input__slot div {
  text-align: center !important;
}
</style>